import { useAppSelector } from '../../../../Redux/store'
import { Blinker } from '../../../Common/Blinker';

export const AboutScreen = () => {

    const { screenPage } = useAppSelector(state => state.screenInteractions);

    const resolveScreenPage = (screenPage: number) => {
        switch (screenPage) {
            case 0:
                return (
                    <>
                        <p style={{ lineHeight: 1.5, textAlign: 'center' }} className="interactions-text text-xs text-center mb-3">Yo!</p>
                        <p style={{ lineHeight: 1.5, textAlign: 'center' }} className="interactions-text text-xs text-center mb-3">
                            Need a nostalgic user interface to build, test and play games inscribed on a blockchain?
                        </p>
                        <p style={{ lineHeight: 1.5, textAlign: 'center' }} className="interactions-text text-xs text-center mb-3">
                            No?
                        </p>
                        <p style={{ lineHeight: 1.5, textAlign: 'center' }} className="interactions-text text-xs text-center mb-3">
                            Well here's one anyway.
                        </p>
                    </>
                )
            case 1:
                return (
                    <>
                        <p className="interactions-text text-xs text-center mb-3">WowBoi is simply a way to give a more enjoyable indie gaming experience in web3, to both players & creators.</p>
                    </>
                )
            case 2:
                return (
                    <>
                        <p className="interactions-text text-xs text-center mb-3">By hooking into the WowBoi API, developers get access to features which offer a smoother gaming experience to their users.</p>
                    </>
                )
            case 3:
                return (
                    <>
                        <p className="interactions-text text-xs text-center mb-3">And players get a comfortable yet familiar UI to enjoy their games with!</p>
                    </>
                )
            // case 4:
            //     return (
            //         <>
            //         <p className="interactions-text text-xs text-center mb-3">Check out our humble demo games, inscribed on both the Bellscoin and Bitcoin Blockchains, available to play from the home screen.</p>
            //         <p className="interactions-text text-xs text-center mb-3">With more demo games to play, coming soon!</p>
            //         </>
            //     )
            case 4:
                return (
                    <>
                        <p className="interactions-text text-xs text-center mb-3">View the WowBoi docs link on the homescreen, for more information on how everything works.</p>
                        <p className="interactions-text text-xs text-center mb-3">Note: The Developer Sandbox is currently only available for Desktop (for now!).</p>
                    </>
                )
            case 5:
                return (
                    <>
                        <p className="interactions-text text-xs text-center mb-3">We've also released "cartridge one": the first game collection on Bellschain!</p>
                        <p className="interactions-text text-xs text-center mb-3">151 humble games, each under 1.5kb, with 20 one-of-ones available from Bellscribe.</p>
                        <p className="interactions-text text-xs text-center mb-3">Link on the WowBoi homescreen.</p>
                    </>
                )
            case 6:
                return (
                    <>
                        <p className="interactions-text text-xs text-center mb-3">The WowBoi project was born out of love for both past & future technology.</p>
                        <p className="interactions-text text-xs text-center mb-3">Hope you enjoy!</p>
                        <p className="interactions-text text-xs text-center m-x-3">fromp</p>
                    </>
                )
        }
    }

    return (
        <div className="h-full flex flex-col justify-center items-center relative py-3 px-4 box-border">
            {resolveScreenPage(screenPage)}
            <div className="flex max-w-3/5 w-full absolute bottom-[6px] justify-between px-2">
                <p className='interactions-text text-xs'>
                    <Blinker interval={550}>
                        <span>
                            {"<"} Z
                        </span>
                    </Blinker>
                </p>
                <p className='interactions-text text-xs'>
                    <Blinker interval={550}>
                        <span>
                            X {">"}
                        </span>
                    </Blinker>
                </p>
            </div>
        </div>
    )
}
